<template>
  <van-overlay
    show
    class-name="before-leave-overlay overflow-y-auto"
    z-index="1000"
  >
    <div>
      <div ref="mountDialogNode">
        <van-dialog
          :value="true"
          :overlay="false"
          title="继续答题可参与抽奖"
          message="确认放弃抽奖机会？"
          show-cancel-button
          cancel-button-text="放弃答题"
          confirm-button-text="继续答题"
          :getContainer="getContainer"
          @confirm="$emit('confirm')"
          @cancel="$emit('cancel')"
        >
        </van-dialog>
      </div>

      <div class="relative">
        <luck :answer-id="answerId" :survey-id="surveyId" :bindEnabled="false" :readOnly="true" />
        <div class="absolute inset-0 z-10"></div>
      </div>
    </div>
  </van-overlay>
</template>

<script>
import Luck from 'components/luck/Luck'

export default {
  name: 'BeforeLeaveOverlay',
  components: { Luck },
  props: {
    answerId: {
      type: String,
      required: true
    },
    surveyId: {
      type: String,
      required: true
    }
  },
  methods: {
    getContainer() {
      return this.$refs.mountDialogNode
    }
  }
}
</script>

<style lang="scss">
.before-leave-overlay {
  display: flex;
  & > div {
    margin: auto;
  }
  .van-dialog {
    position: static;
    transform: translate3d(0, 0, 0);
    margin: 0 auto;
  }
  
  .luck-container {
    background-image: url('/assets/img/before-leave-luck.png');
    background-size: cover;
    background-repeat: no-repeat;
  }
  //.turntable-box {
  //  background-color: #fff;
  //  padding: 0 15px;
  //}
}
</style>